import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setAlertSuccess: (state, action) => {
      return { type: "success", message: action.payload, open: true };
    },
    setAlertError: (state, action) => {
      return { type: "error", message: action.payload, open: true };
    },
    setAlertInfo: (state, action) => {
      return { type: "info", message: action.payload, open: true };
    },
    setAlertWarning: (state, action) => {
      return { type: "warning", message: action.payload, open: true };
    },
    clearAlert: (state) => {
      return { ...state, open: false };
    },
  },
});

const { reducer, actions } = alertSlice;

export const {
  setAlertSuccess,
  setAlertError,
  setAlertInfo,
  setAlertWarning,
  clearAlert,
} = actions;

// Thunk action to dispatch the clearAlert action after a delay of 30 seconds
export const clearAlertWithDelay = () => (dispatch) => {
  setTimeout(() => {
    dispatch(clearAlert());
  }, 30000); // Update the delay value to 30000 milliseconds for 30 seconds
};

export default reducer;
